module.exports = __webpack_public_path__ + "img/hsup.0c066faf.png";